// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__pHuah","col":"CardReaderDesc_col__2wW4K","label":"CardReaderDesc_label__fIMq8"};